import { Injectable } from '@angular/core';
import { DbRecord } from './db-record'
import { Http } from '@angular/http';
import { CrossrefRecord } from './crossref-record'


@Injectable()
export class CrossrefService {

  constructor(
    private http: Http
  ) { }

  doiRun(dbRecord: DbRecord) {
    let obs = this.http.get(`https://api.crossref.org/works/${dbRecord.doi}`)
    let ls = []
    obs.subscribe(resp => {
      ls.push(new CrossrefRecord(resp.json()['message']))
      console.log(ls)
    })

    return [obs, ls]
  }

  titleRun(dbRecord: DbRecord) {
    let ls = []
    let title = dbRecord.title
      .replace(/[^A-Za-z0-9]/g, ' ').trim().toLowerCase()
      .replace(/\s+/g, '+');
    let obs = this.http.get(`https://api.crossref.org/works?query=${title}&rows=10`);
    obs.subscribe(resp =>
      resp.json()['message']['items'].forEach(itm => {
        ls.push(new CrossrefRecord(itm))
      }));
      return [obs, ls];
  }

  issnRun(issn: string) {
    let ls = [];
    let obs = this.http.get(`https://api.crossref.org/journals/${issn}`);
    obs.subscribe(resp => {
      console.log(888, resp.json()['message'])
    });
    return [obs, ls];
  }


}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/crossref.service.ts